import { $ } from '@/Engine/stateInstance';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { Group, Mesh, Vector3, MeshBasicMaterial } from 'three';
import { textMaterial } from '@/Engine/Ruler/material';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';

export class SimpleTextMesh {
    private loader = new FontLoader();
    readonly model: Group=new Group();
    textMesh: Mesh;
    textGeometry: TextGeometry;

    constructor(text:string) {
        if (!$.font) return;

        // this.textGeometry = this.getTextGeometry(text);
        const geometry = this.getTextGeometry(text,0.04);
        if (!geometry) return;
        this.textMesh = new Mesh(geometry, new MeshBasicMaterial(
            { color: 0x000000 },
        ));
        this.textMesh.renderOrder = 1;
        // textMesh.rotation.y = Math.PI/2;
        // textMesh.position.z = text.length*0.06;
        this.textMesh.scale.set(1,1,0.002);
        this.model.add(this.textMesh);
    }

    getTextGeometry(text: string,fontSize=0.03) {
        if (!$.font) return;
        return new TextGeometry(text, {
            font: $.font,
            size:fontSize,
            height: 0.035,
            // bevelEnabled: true,
            // bevelThickness: 8,
            curveSegments: 5,
        });
    }

}
